<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <img src="@/assets/century/13.png" class="imgs" alt="" srcset="">
        <div class="input">
          <van-search clearable @clear='clear()' v-model="value" placeholder="请输入选手编号或名称" />
        </div>
        <div class="searchBtn">
          <van-button @click="gotoVote()" type="primary">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close" >
      <van-icon @click='close()' name="close"  />
    </div>
  </div>
</template>

<script>
  import searchMixin from "@/mixins/search.js"
  export default {
    mixins:[searchMixin],
  }
</script>

<style lang="less" scoped>
.search{
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox{
    width: 9.2rem;
    height: 3.2rem;
    box-sizing: border-box;
    position: relative;
    .content{
      padding-bottom: 20px;
      width: 96%;
      border: 12px solid #ce3227;
      box-sizing: border-box;
      background: #fcf4ed;
      position: absolute;
      bottom: .2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: .1rem;
      .imgs{
        width: 4.50667rem;
        height: .8rem;
        margin-left: 50%;
        transform: translateX(-50%);
        padding-top: .53333rem;
      }
      .input{
        margin: .8rem 0 .8rem;
        width: 98%;
        margin-left: 1%;
        .van-search{
          background: #ffffff;
          padding: 0;
          margin: 0 .2666667rem;
          border-radius: .8rem;
          /deep/.van-search__content{
            border-radius: 50px;
          }
        }
        /deep/.van-icon-search{
          color: #ca1a03;
        }
      }
      .searchBtn{
        height: .96rem;
        width: 80%;
        box-sizing: border-box;
        margin-left: 10%;
        .van-button{
          width: 100%;
          height: 100%;
          color: #bf2f19;
          background: url('@/assets/century/155.png') no-repeat;
          background-size: 100%;
          border: none;
        }
      }
    }
  }
  div.close{
    margin-top: .5333333rem;
    .van-icon-close{
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>